module.exports = __webpack_public_path__ + "static/blog14-5f6ffeab3ee713911d3935634dba40e6.png";